/**
 * This is a dummy page that uses axios directly to test the APIs in the backend works well
 * for frontend
 */

import React, { useState, useEffect } from "react"
import axios from "axios"
import { PORT } from "../../../config"
import ConfirmButton from "../../../Components/Buttons/ConfirmButton"

const DummyRequest = (props) => {

    const submitRequest = (e) => {

       // console.log('########### 0, clicked')
    
    // =========================================
    // General Updates
    // -----------------------------------------

        // =================== Create ========================
        // const data = {
        //     responsibilities: [],
        //     benefits: [
        //         "fsdf"
        //     ],
        //     days: [
        //         "Mon"
        //     ],
        //     inst_id: "5ee80ff44b6f80f139be9f5b",
        //     publisher_id: "5ee80ff44b6f80f139be9f5b",
        //     location: "5ee80ff44b6f80f139be9f5b",
        //     title: "abs",
        //     admin_note: "dsadsa",
        //     pub_date: new Date(),
        //     close_date: new Date(),
        //     start_date: new Date(),
        //     end_date: new Date(),
        //     weekly_hours: 1,
        //     hourly_rate_min: 1,
        //     hourly_rate_max: 2,
        //     hourly_rate_unit: "fsd",
        //     salary_min: 4,
        //     salary_max: 5,
        //     salary_unit: "dsada",
        //     level: "dsadsa",
        //     tags: {
        //         ge: [],
        //         exam: [],
        //         academic: [],
        //         vet: [],
        //         other: [],
        //     },
        //     status: "draft",
        //     interview_requested: false,
        // }

        // axios.post(`${PORT}/CreateListing`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })
    
        // =================== Delete ========================
        // axios.delete(`${PORT}/DeleteListing`, {data: {_id: '6010a36534fb161ec0e1d61b'} })
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })


        // ================== Update =======================

        // const data = {
        //     _id: '600e4f6a97872c4df069d2ef',
        //     responsibilities: [],
        //     benefits: [
        //         "fsdf"
        //     ],
        //     days: [
        //         "Mon"
        //     ],
        //     inst_id: "5ee80ff44b6f80f139be9f5b",
        //     publisher_id: "5ee80ff44b6f80f139be9f5b",
        //     location: "5ee80ff44b6f80f139be9f5b",
        //     title: "abs",
        //     admin_note: "dsadsa",
        //     pub_date: new Date(),
        //     close_date: new Date(),
        //     start_date: new Date(),
        //     end_date: new Date(),
        //     weekly_hours: 1,
        //     hourly_rate_min: 1,
        //     hourly_rate_max: 2,
        //     hourly_rate_unit: "fsd",
        //     salary_min: 4,
        //     salary_max: 5,
        //     salary_unit: "dsada",
        //     level: "dsadsa",
        //     tags: {
        //         ge: [],
        //         exam: [],
        //         academic: [],
        //         vet: [],
        //         other: [],
        //     },
        //     status: "draft",
        //     interview_requested: true,
        //     applicants: [],
        //     invited_apply: [],
        //     invited_interview: [],
        //     selected: []
        // }

        // axios.post(`${PORT}/UpdateListing`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // ================== Update Listing Status ===========================

        // const data = {
        //     _id: '600e4f6a97872c4df069d2ef', 
        //     status: 'published',
        // }

        // axios.put(`${PORT}/UpdateListingStatus`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })


    // ===========================================
    // Linking/Unlinking Teachers with Listings
    // -------------------------------------------

        // ================ Apply for a job ==============================
        // const data = {
        //     listing_id: '600e39a49b692b5428a1ca9d',
        //     teacher_id: '5e67017b6d0f336298a0c65c',
        // }

        // axios.post(`${PORT}/ApplyForListing`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // =============== Cancel application above ========================
        // const data = {
        //     listing_id: '600e39a49b692b5428a1ca9d',
        //     teacher_id: '5e67017b6d0f336298a0c65c',
        // }

        // axios.post(`${PORT}/CancelApplication`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // ================ Invite to a job listing ==============================
        // const data = {
        //     listing_id: '600e39a49b692b5428a1ca9d',
        //     teacher_id: '5e67017b6d0f336298a0c65c',
        // }

        // axios.post(`${PORT}/InviteToListing`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // =============== Cancel listing invitation ========================
        // const data = {
        //     listing_id: '600e39a49b692b5428a1ca9d',
        //     teacher_id: '5e67017b6d0f336298a0c65c',
        // }

        // axios.post(`${PORT}/CancelInvitation`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // ================ Invite to an interview ==============================
        // const data = {
        //     listing_id: '600e39a49b692b5428a1ca9d',
        //     teacher_id: '5e67017b6d0f336298a0c65c',
        // }

        // axios.post(`${PORT}/InviteToInterview`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // =============== Cancel an interview ========================
        // const data = {
        //     listing_id: '600e39a49b692b5428a1ca9d',
        //     teacher_id: '5e67017b6d0f336298a0c65c',
        // }

        // axios.post(`${PORT}/CancelInterview`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // ================ Offer a job to a teacher ==============================
        // const data = {
        //     listing_id: '600e39a49b692b5428a1ca9d',
        //     teacher_id: '5e67017b6d0f336298a0c65c',
        // }

        // axios.post(`${PORT}/OfferJob`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // =============== Cancel an offer ========================
        // const data = {
        //     listing_id: '600e39a49b692b5428a1ca9d',
        //     teacher_id: '5e67017b6d0f336298a0c65c',
        // }

        // axios.post(`${PORT}/CancelOffer`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // ================ Save to my favourite ==============================
        // const data = {
        //     listing_id: '600e39a49b692b5428a1ca9d',
        //     teacher_id: '5e67017b6d0f336298a0c65c',
        // }

        // axios.post(`${PORT}/SaveAsFavourite`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // =============== Remove from my favourite ========================
        // const data = {
        //     listing_id: '600e39a49b692b5428a1ca9d',
        //     teacher_id: '5e67017b6d0f336298a0c65c',
        // }

        // axios.post(`${PORT}/RemoveFromFavourite`, data)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

    // ============================================
    // get listings
    // --------------------------------------------

        // =============== All Listings ====================
        // axios.get(`${PORT}/getallListings`)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // ============== By Listing Id ===================
        // axios.get(`${PORT}/getListingById?id=600e4a95698dea3da82a9e3e`)
        // .then(result => {
        //     console.log(result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // ============== Get listings related to a teachers ======================

        // 5e95560b0b12bf738c24d3cb

        // axios.get(`${PORT}/GetMyApplications?teacher_id=5e67017b6d0f336298a0c65c`)
        // .then(result => {
        //     console.log('my app', result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // axios.get(`${PORT}/GetMyInvitations?teacher_id=5e67017b6d0f336298a0c65c`)
        // .then(result => {
        //     console.log('my invite', result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // axios.get(`${PORT}/GetMyInterviews?teacher_id=5e67017b6d0f336298a0c65c`)
        // .then(result => {
        //     console.log('my interview', result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // axios.get(`${PORT}/GetMyOffers?teacher_id=5e67017b6d0f336298a0c65c`)
        // .then(result => {
        //     console.log('my offer', result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // axios.get(`${PORT}/GetMyFavourite?teacher_id=5e67017b6d0f336298a0c65c`)
        // .then(result => {
        //     console.log('my favourite', result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // // ============== Get teachers related to a listing ======================

        // axios.get(`${PORT}/GetApplicants?listing_id=600e39a49b692b5428a1ca9d`)
        // .then(result => {
        //     console.log('applicants', result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // axios.get(`${PORT}/GetInvitees?listing_id=600e39a49b692b5428a1ca9d`)
        // .then(result => {
        //     console.log('invited', result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // axios.get(`${PORT}/GetInterviewees?listing_id=600e39a49b692b5428a1ca9d`)
        // .then(result => {
        //     console.log('interviewed', result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })

        // axios.get(`${PORT}/GetSelected?listing_id=600e39a49b692b5428a1ca9d`)
        // .then(result => {
        //     console.log('offered', result)
        // })
        // .catch(err => {
        //     console.log(err)
        // })
    }

    return (
        <div>
            <ConfirmButton onClick={submitRequest}>Submit</ConfirmButton>
        </div>
    )
}

export default DummyRequest





































